export enum FeedbackEndpoints {
    PostFeedback = '/v1/feedback',
    PostAttachmentFile = '/v1/feedback/attachment',
}
